import { motion } from 'framer-motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';
import { hudCopy } from '../content';
import { HudPanel, ModuleHeader, ScannerOverlay, StatusIndicator, SystemFrame } from '../primitives';

export const DeliveryPipelineScreen = () => {
  const reducedMotion = useReducedMotion();

  return (
    <SystemFrame id="delivery-pipeline" className="min-h-[calc(100vh-6.5rem)] pt-24">
      <HudPanel pulse className="relative">
        <ScannerOverlay tone="normal" />
        <ModuleHeader
          index="SCREEN 05"
          title={hudCopy.pipeline.heading}
          subtitle={hudCopy.pipeline.subtitle}
          tag="EXECUTION TRACK"
          status={hudCopy.microLabels.nominal}
        />

        <HudPanel pulse className="relative mt-8 overflow-hidden bg-brand-panel-2/72">
          <div className="pointer-events-none absolute left-6 right-6 top-1/2 hidden h-px -translate-y-1/2 bg-gradient-to-r from-brand-lime/15 via-brand-lime/80 to-brand-lime/15 lg:block" />

          <div className="grid gap-4 lg:grid-cols-4">
            {hudCopy.pipeline.stages.map((stage, index) => (
              <article key={stage.title} className="relative rounded-xl border border-brand-lime/22 bg-brand-panel/70 px-4 py-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="hud-chip">{`STEP 0${index + 1}`}</span>
                  <motion.span
                    className="h-2.5 w-2.5 rounded-full bg-brand-lime"
                    animate={reducedMotion ? undefined : { opacity: [0.35, 1, 0.45], scale: [0.8, 1.25, 0.9] }}
                    transition={{ duration: 1.5, repeat: Infinity, delay: index * 0.2 }}
                  />
                </div>

                <h3 className="mt-4 text-lg font-semibold text-brand-text">{stage.title}</h3>
                <p className="mt-1 text-xs uppercase tracking-[0.18em] text-brand-lime">{stage.tag}</p>
                <p className="mt-3 text-sm text-brand-text-2">{stage.body}</p>
                <div className="mt-5">
                  <StatusIndicator label="PIPELINE ACTIVE" />
                </div>

                {index !== hudCopy.pipeline.stages.length - 1 ? (
                  <motion.div
                    className="pointer-events-none absolute right-[-20px] top-1/2 hidden h-[2px] w-9 bg-gradient-to-r from-brand-lime/70 to-transparent lg:block"
                    animate={reducedMotion ? undefined : { opacity: [0.2, 1, 0.35], scaleX: [0.7, 1, 0.75] }}
                    transition={{ duration: 1.4, repeat: Infinity }}
                  />
                ) : null}
              </article>
            ))}
          </div>

          <motion.div
            className="pointer-events-none absolute inset-y-0 left-[-20%] w-[20%] bg-[linear-gradient(90deg,transparent,rgba(183,255,106,0.24),transparent)]"
            animate={reducedMotion ? undefined : { x: ['0%', '620%'] }}
            transition={{ duration: 3.8, repeat: Infinity, ease: 'linear' }}
          />
        </HudPanel>
      </HudPanel>
    </SystemFrame>
  );
};
